// export { default } from './api'
export * from './api'
//这里面对应着四个方法 get put post del四个方法

import { http,get,post,put,del} from './api'


const apiServe = {
    // 登录接口函数
    // login是自定义名称，定义login的原因是因为他是登录接口
    // login:(data,method) => http('/login',method,data),


    // 确定好什么方法之后，直接传递参数过来就行，在这边写get post put del
    getIndexData: (data, method) => get('/api/index/index', data),
    getAboutData: (data, method) => get('/api/index/about', data),
    postProductData: (data, method) => post('/api/index/product', data),
    getCaseData: (data, method) => post('/api/index/cases', data),
    getNewsData: (data, method) => post('/api/index/news', data),
    getContactData: (data, method) => get('/api/index/contact', data),
    postMessageData: (data, method) => post('/api/index/message', data),
    getRDData: (data, method) => post('/api/index/rd', data),

    postNewsDetailData: (data, method) => post('/api/index/newsD', data),
    postProductDetailData: (data, method) => post('/api/index/productD', data),
    postCaseDetailData: (data, method) => post('/api/index/casesD', data),

}

export default apiServe